export default "__VITE_ASSET__Bwn1hCfR__"